import { FieldAgentClient, Product2, ManualOrderLineType, Per, Tally } from 'ep-bt-field-agent-proxy';
import { QuantityType } from 'ep-bt-controls';
import { QuickOrderModel } from './quick-order.model';
import { TallyEntryLineModel } from './tally-entry-line.model';
import { EpbtFaTallyModel } from './epbt-fa-tally.model';


export class QuickOrderLineModel {

    constructor(quickOrder: QuickOrderModel, product: Product2, qtyType: QuantityType, quantity: number, quantityTally: string = '') {
        this.IsManuallyPriced = false;
        this.quickOrder = quickOrder;
        this.Product = product;
        this.QtyType = qtyType;
        switch (qtyType) {
            case QuantityType.Per:
                this.Quantity = quantity;
                break;
            case QuantityType.Tally:
                this.QuantityTally = quantityTally;
                break;
            default:
                break;
            // throw new NotSupportedException(string.Format('{0} of {1} is unsupported in QuickOrder.Data.Line', typeof(QuantityType).Name, qtyType.ToString()));
        }
    }

    // Just for display start
    public code: string;
    public description: string;
    // Just for display end

    public LineNotes: string;
    public SpecialProductDescription: string;
    public ManualDescription: string;
    public ManualCode: string;
    public Product: Product2;
    public ManualOrderLineType: ManualOrderLineType;
    public QtyType: QuantityType;
    public Quantity: number;
    public InputPer: Per;

    /// <summary>
    /// ! Do not includes discounts
    /// </summary>

    private _UnitSellPrice: number;
    public get UnitSellPrice(): number {
        return this._UnitSellPrice;
    }
    public set UnitSellPrice(value: number) {
        this._UnitSellPrice = value;
        // this._UnitSellPrice = Math.Round(value, 2); // always force 2 number places for price
    }
    /// <summary>
    /// Sell Per
    /// </summary>
    public Per: Per;

    public Discount1 = 0;
    public Discount2 = 0;

    /// <summary>
    /// Includes Discounts
    /// </summary>
    public TotalSellPrice: number;

    public UnitCostPrice: number;
    public CostPer: Per;

    public Profit: number;
    public TotalMargin: number;

    public TotalTax = 0;
    // #region Tally related properties
    public QuantityTally: string;

    public TotalTallyArea: number;
    public TotalTallyVolume: number;
    public TotalTallyLength: number;


    public TotalTallyAreaMetric: number;
    public TotalTallyVolumeMetric: number;
    public TotalTallyLengthMetric: number;

    public Tally: EpbtFaTallyModel;
    public TallyEntryLines: TallyEntryLineModel[] = [];

    /// <summary>
    /// Will be used for rendering order line to omit/include
    /// tally information
    /// </summary>
    public IsTally: boolean;
    private _IsImperial: boolean;
    public get IsImperial(): boolean {
        return this.Product.imperial;
    }

    // #endregion

    public Adding: boolean; // helper flag

    private _LineNumber: number;
    public get LineNumber(): number {
        return this.lineNumber;
    }

    private _UnitSellPriceDisplay: string;
    public get UnitSellPriceDisplay(): string {
        // return String.Format('{0:N2}', this.unitSellPrice);
        return this.unitSellPrice.toFixed(2);
    }

    private _TotalSellPriceDisplay: string;
    public get TotalSellPriceDisplay(): string {
        // return String.Format('{0:N2}', this.TotalSellPrice);
        return this.TotalSellPrice.toFixed(2);
    }

    private _Discount1Display: string;
    public get Discount1Display(): string {
        // return String.Format('{0:N2}', this.Discount1);
        return this.Discount1.toFixed(2);
    }

    private _Discount2Display: string;
    public get Discount2Display(): string {
        // return String.Format('{0:N2}', this.Discount2);
        return this.Discount2.toFixed(2);
    }

    public SetLineNumber(lineNumber: number) {
        this.lineNumber = lineNumber;
    }

    private quickOrder: QuickOrderModel;
    private lineNumber: number;
    private unitSellPrice: number;


    public PerToDisplay: Per;

    public IsManuallyPriced: boolean;
    public OldPerId: number; // previous PerID
    /// <summary>
    /// To store current standard price by choosen UOM
    /// </summary>
    public CurrentStandardUnitSellPrice: number;

}
